document.addEventListener('page:loaded', function() {

/*============================================================================
  CLEAR LOCAL STORAGE ON RELOAD
==============================================================================*/
  localStorage.clear();

/*============================================================================
  HIDE COMPLETE YOUR COLLECTION, IF NO ITEMS
==============================================================================*/
  if (meta_data_add_to_cart && meta_data_design_your_own) {
    if (Object.keys(meta_data_add_to_cart).length == 0 && Object.keys(meta_data_design_your_own).length == 0) {
     document.querySelector('[data-section-type="product-recommendations"]').classList.add('hide');
    }
  }

/*============================================================================
  INITIALIZE MAKE IT PERSONAL POPUP
==============================================================================*/

  const mipTrigger = document.querySelector('tool-tip-trigger#make-it-personal');

  mipTrigger.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();

      initTransform();
      initSelectButton();
      initRadioSelections();
      initCommentsField();
      initTextFields();
      initHeightField();
      initMipHeightSync();

      // now that every field has restored its saved value, do one final
      // pass so every "Save Your Selections" button reflects the combined
      // state correctly, regardless of which of the inits above ran last
      syncAllSaveButtons();

      setPanels('panel-2');
      

     // set the textarea to stored value
      if (localStorage.getItem('Pillow Comments') != null) {
         document.querySelector('tool-tip #pillowComments').value = localStorage.getItem('Pillow Comments');
      }


      // handle back buttons
      const backButtons = document.querySelectorAll('.back-button');
      backButtons.forEach((button) => {
        button.addEventListener('click', event => {
          event.preventDefault();

          // set to last panel — Back only ever appears on panels 2-5, so
          // this should always just decrement; panelNum < 5 previously
          // excluded panel-5's own Back button, resetting it to itself
          // instead of going back to panel-4
          var currentPanel = event.target.closest('.content').id;
          let panelNum = +currentPanel.replace('panel-', '');

          if (panelNum > 1) {
            panelNum = panelNum-1;
          }
          setPanels('panel-' + panelNum);

        });
      });


  });

});



/*============================================================================
  MAKE IT PERSONAL - FUNCTIONS
==============================================================================*/

function addLineItem(value, name) {
  var liname = name;
  var lival = value;

  // Get the form element
  var form = document.querySelector('.product-single__form');

  // Create the input element
  var input = document.createElement('input');

  // Set the attributes of the input element
  input.type = 'hidden';
  input.name = 'properties['+ liname +']';
  input.value = lival;

  // Append the input element to the form
  form.appendChild(input);
}

function initTransform() {
  const buttons = document.querySelectorAll('.mip-container .tab');
  buttons.forEach((button) => {
    button.addEventListener('click', event => {
      event.preventDefault();
      const target = button.dataset.target;
      setPanels(target);

    });
  });
}

// .content panels are position:absolute (so the tab-switch translateX slide
// in pillowbar.css.liquid works), which means .contents (their
// position:relative wrapper) never grows to fit them - an absolutely
// positioned box contributes nothing to its containing block's own height.
// .contents was left with a flat min-height: 65vh instead, so any panel
// whose actual content was taller than that got silently cut off:
// .mip-container's own overflow-y: auto never saw the extra height to
// scroll to, since .contents itself never reported being any taller than
// 65vh regardless of what its absolutely positioned children rendered.
// Measuring the active panel's real height here and applying it as
// .contents' own min-height keeps that 65vh floor for shorter panels
// while letting taller ones expand the container - mip-container's own
// max-height/overflow then handles scrolling within the viewport as before.
var currentMipPanelTarget = null;

function syncContentsHeight(target) {
  // document.getElementById(target)/a singular .contents lookup would only
  // ever reach the FIRST matching element - the page can have more than one
  // .mip-container (confirmed live: a second, inactive copy sits earlier in
  // the DOM), each with its own element sharing this same id. Matching
  // setPanels' own approach above (querySelectorAll + forEach over every
  // instance) instead of trusting getElementById avoids silently sizing
  // whichever instance isn't the one actually on screen.
  var minFloor = window.innerHeight * 0.65;
  document.querySelectorAll('.mip-container .content').forEach(function(content) {
    if (content.id !== target) {
      return;
    }
    var contentsWrapper = content.closest('.contents');
    if (!contentsWrapper) {
      return;
    }
    contentsWrapper.style.minHeight = Math.max(content.scrollHeight, minFloor) + 'px';
  });
}

// Switching tabs isn't the only way a panel's content can grow taller than
// what syncContentsHeight last measured - picking an option that reveals
// more fields within the SAME panel (e.g. a style select that shows extra
// text inputs) does too, without ever calling setPanels again. rAF-
// debounced since typing fires 'input' repeatedly and this only needs to
// run once per frame.
var mipHeightSyncScheduled = false;
function scheduleMipHeightSync() {
  if (mipHeightSyncScheduled) {
    return;
  }
  mipHeightSyncScheduled = true;
  window.requestAnimationFrame(function() {
    mipHeightSyncScheduled = false;
    if (currentMipPanelTarget) {
      syncContentsHeight(currentMipPanelTarget);
    }
  });
}

var mipHeightSyncListenerAttached = false;
function initMipHeightSync() {
  var container = document.querySelector('.mip-container');
  if (!container || mipHeightSyncListenerAttached) {
    return;
  }
  mipHeightSyncListenerAttached = true;
  container.addEventListener('input', scheduleMipHeightSync);
  container.addEventListener('change', scheduleMipHeightSync);
}

function setPanels(target) {
  const contents = document.querySelectorAll('.mip-container .content');
  contents.forEach((content) => {

    if (window.innerWidth < 768 && content.id != 'panel-5') {
      // Code to be executed if the screen width is less than 768 pixels

        if (content.id === target) {
          content.style.transform = 'translate(0, 0%)';
        } else {
          content.style.transform = 'translate(100%, 0%)';
        }

    } else {
      if (content.id === target) {
        content.style.transform = 'translateX(0)';
      } else {
        content.style.transform = 'translateX(100%)';
      }
    }


  });

  const tabs = document.querySelectorAll('.mip-container .tab');
  tabs.forEach((tab) => {
    if (tab.dataset.target === target) {
      tab.classList.add('active');
    } else {
      tab.classList.remove('active');
    }
  });

  currentMipPanelTarget = target;
  syncContentsHeight(target);
}

function initSelectButton() {

  const buttons = document.querySelectorAll('.mip-container .select-button');
  buttons.forEach((button) => {

    button.addEventListener('click', event => {
      event.preventDefault();

      // use currentTarget (the button the listener is attached to), not
      // target — a click on a nested element like the <span class="underline">
      // inside some of these buttons would otherwise make target.id come back
      // empty, silently skipping the id checks below
      var triggerButton = event.currentTarget;

      var modalWindow = triggerButton.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
      var htmlDiv = triggerButton.closest('html');

      if (triggerButton.id == 'MIP-save') {

        // save the comments to localStorage before the sweep below, so it
        // picks the value up and adds it to the cart form from there (same
        // as Height/Gender/Age) — calling addLineItem directly here too, on
        // top of the sweep, used to create a second hidden input with the
        // exact same name="properties[Pillow Comments]", which broke the
        // value actually reaching the cart
        var lineValue = triggerButton.closest('.content').querySelector('textarea').value;
        var lineName =  triggerButton.closest('.content').querySelector('textarea').name

        // Comments is optional - only save (and later sweep into the cart)
        // a real value. Leaving an empty string in localStorage would still
        // get swept into a "properties[Pillow Comments]" line item below,
        // which then shows as a blank "Comments:" line in the cart even
        // though nothing was actually entered.
        if (lineValue.trim() !== '') {
          localStorage.setItem(lineName, lineValue);
        } else {
          localStorage.removeItem(lineName);
        }

        // now get all the radio values and save them as line items
        for (var i = 0; i < localStorage.length; i++) {
          var key = localStorage.key(i);
          if (key.includes('Height') || key.includes('Age') || key.includes('Gender') || key.includes('Pillow Comments')) {
            var value = localStorage.getItem(key);
            addLineItem(value, key);
          }

        }


        // make the button purple
        var element = document.querySelector(".tool-tip-trigger__title.pb-button");
        //element.classList.remove("pb-button");
        element.classList.add("pb-button_tertiary");

        // close the modal
        modalWindow.setAttribute('data-tool-tip-open', 'false');
        htmlDiv.classList.remove('modal-open');
        allowScroll();

      } else if (triggerButton.id == 'GENDER-save' || triggerButton.id == 'AGE-save' || triggerButton.id == 'HEIGHT-save') {

        // save the closest value — Gender is still a radio group, Height
        // is feet+inches combined into one value, Age is a plain text input
        var closestRadio = triggerButton.closest('.content');
        if (closestRadio) {
          var isChecked = closestRadio.querySelector('input[type="radio"]:checked');
          var heightValue = getHeightValue(closestRadio);
          var textInput = closestRadio.querySelector('input[type="text"]:not(#heightFeetInput):not(#heightInchesInput)');

          if (isChecked) {
            var selectedName = isChecked.name;
            var selectedValue = isChecked.value;
            saveOption(selectedName, selectedValue, triggerButton);
          } else if (heightValue !== null) {
            saveOption('Height', heightValue, triggerButton);
          } else if (textInput && textInput.value.trim() !== '') {
            saveOption(textInput.name, textInput.value.trim(), triggerButton);
          }
        }

         // now get all the radio values and save them as line items
        for (var i = 0; i < localStorage.length; i++) {
          var key = localStorage.key(i);
          if (key.includes('Height') || key.includes('Age') || key.includes('Gender') || key.includes('Pillow Comments')) {
            var value = localStorage.getItem(key);
            addLineItem(value, key);
          }

        }

        // make the button purple
        var element = document.querySelector(".tool-tip-trigger__title.pb-button");
        //element.classList.remove("pb-button");
        element.classList.add("pb-button_tertiary");

        // close the modal
        modalWindow.setAttribute('data-tool-tip-open', 'false');
        htmlDiv.classList.remove('modal-open');
        allowScroll();

      } else if (triggerButton.id == 'MIP-cancel') {

        // close the modal
        modalWindow.setAttribute('data-tool-tip-open', 'false');
        htmlDiv.classList.remove('modal-open');
        allowScroll();

      } else {

        //var selectedValue = triggerButton.closest('.content').querySelector('input[type="radio"]:checked').value;
        //var selectedName = triggerButton.closest('.content').querySelector('input[type="radio"]:checked').name;
        var saveButton = triggerButton.parentNode.parentNode.closest('.contents').querySelector('#panel-5 #MIP-save');

        // save the closest value — Gender is still a radio group, Height
        // is feet+inches combined into one value, Age is a plain text input
        var closestRadio = triggerButton.closest('.content');
        if (closestRadio) {
          var isChecked = closestRadio.querySelector('input[type="radio"]:checked');
          var heightValue = getHeightValue(closestRadio);
          var textInput = closestRadio.querySelector('input[type="text"]:not(#heightFeetInput):not(#heightInchesInput)');

          if (isChecked) {
            var selectedName = isChecked.name;
            var selectedValue = isChecked.value;
            saveOption(selectedName, selectedValue, triggerButton);
          } else if (heightValue !== null) {
            saveOption('Height', heightValue, triggerButton);
          } else if (textInput && textInput.value.trim() !== '') {
            saveOption(textInput.name, textInput.value.trim(), triggerButton);
          }
        }

        //if (selectedValue !== undefined) {

         // saveOption(selectedName, selectedValue, triggerButton);
        //}

        // we can enable the buttons
        if (saveButton) saveButton.removeAttribute('disabled');


        // set to next panel
        var currentPanel = triggerButton.closest('.content').id;
        let panelNum = +currentPanel.replace('panel-', '');

        if (panelNum < 5) {
          panelNum = panelNum+1;
        } else {
          panelNum = 5;
        }
        setPanels('panel-' + panelNum);
      }

    }); // end event listener

  });
}

function saveOption(selectedName, selectedValue, target) {

   // save the checked value in local storage
  localStorage.setItem(selectedName, selectedValue);

  // show which value was chosen next to the tab label
  var dataId = target.closest('.content').id;
  target.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('.tab[data-target="' + dataId + '"] .option-chosen').textContent = selectedValue;

}

// True as soon as ANY screen in this flow has a value — Gender checked, or
// text in Height/Age/Comments — regardless of which screen the shopper is
// currently viewing. There's no Sleep Style question in this flow, so
// there's no required screen at all.
function mipHasAnyValue() {
  if (document.querySelector('.mip-container input[type="radio"]:checked')) {
    return true;
  }
  var textInputs = document.querySelectorAll('.mip-container #heightFeetInput, .mip-container #heightInchesInput, .mip-container #ageInput, .mip-container #pillowComments');
  for (var i = 0; i < textInputs.length; i++) {
    if (textInputs[i].value.trim() !== '') {
      return true;
    }
  }
  return false;
}

// Every "Save Your Selections" button (.ss-save) across every screen
// enables together as soon as mipHasAnyValue() is true - saving progress
// isn't tied to that specific screen's own field. #MIP-save (Comments,
// panel-5) isn't included here - it stays unconditionally enabled since it
// doubles as that screen's Next/Finish button.
function syncAllSaveButtons() {
  var anyValue = mipHasAnyValue();
  document.querySelectorAll('.mip-container .ss-save').forEach(function(button) {
    if (anyValue) {
      button.removeAttribute('disabled');
    } else {
      button.setAttribute('disabled', 'disabled');
    }
  });
}

// Puts every screen of this popup back to its untouched, freshly-loaded
// state - called after a successful add to cart (see the
// ajaxProduct:added listener below). Without a page reload, nothing else
// would clear these answers out before the shopper configures whatever
// they add next; page:loaded's own localStorage.clear() only runs on a
// genuine navigation, which an AJAX add never triggers. No Sleep Style
// screen in this flow (see mipHasAnyValue above), so - unlike the
// matching function in pillowbar-mip.js.liquid - there's no Next button
// to re-disable; every one of them is already unconditionally enabled
// regardless of any field's value.
function resetMipPopup() {
  localStorage.clear();

  document.querySelectorAll('.mip-container input[type="radio"]:checked').forEach(function(radio) {
    radio.checked = false;
  });

  document.querySelectorAll('.mip-container #heightFeetInput, .mip-container #heightInchesInput, .mip-container #ageInput, .mip-container #pillowComments').forEach(function(input) {
    input.value = '';
  });

  document.querySelectorAll('.mip-container .option-chosen').forEach(function(span) {
    span.textContent = '';
  });

  // addLineItem() (called from the same branches, right after saveOption())
  // appends a NEW hidden properties[...] input to the form every time,
  // rather than replacing one already there - left alone, those pile up
  // and keep getting submitted as line items on every add after this one,
  // even once the visible fields above are cleared out.
  document.querySelectorAll('.product-single__form input[type="hidden"]').forEach(function(input) {
    var name = input.name || '';
    if (name.indexOf('properties[') === 0 && (name.includes('Height') || name.includes('Age') || name.includes('Gender') || name.includes('Pillow Comments'))) {
      input.remove();
    }
  });

  // saveOption() (called from the SS-save/GENDER-save/AGE-save/HEIGHT-save
  // branches above) turns this button purple to show density was already
  // determined - put it back to its untouched look now that the values
  // behind it are gone.
  document.querySelectorAll('.tool-tip-trigger__title.pb-button_tertiary').forEach(function(button) {
    button.classList.remove('pb-button_tertiary');
  });

  syncAllSaveButtons();
}

document.addEventListener('ajaxProduct:added', resetMipPopup);

function initRadioSelections() {

  const radios = document.querySelectorAll('.content input[type="radio"]');
  radios.forEach(radio => {

    const selectedRadioValue = localStorage.getItem(radio.name);

    if (selectedRadioValue !== null && radio.value === selectedRadioValue) {

      radio.checked = true;

      // also set the span of the selected tab to this value
      var dataId = radio.closest('.content').id;
      var optionChosen = radio.closest('.mip-container').querySelector('.tab[data-target="' + dataId + '"] .option-chosen');
      if (optionChosen) {
        optionChosen.textContent = selectedRadioValue;
      }
    }

    // Next buttons are never disabled here - there's no required question
    // in this flow. "Save Your Selections" buttons across every screen are
    // handled together by syncAllSaveButtons().
    radio.addEventListener('change', syncAllSaveButtons);
  });
}

function initCommentsField() {
  // there are duplicate mobile/desktop copies of the whole widget sharing
  // the same ids, so a singular querySelector could grab the wrong copy's
  // save button — pair each textarea with the save button in its own copy
  const commentsFields = document.querySelectorAll('.mip-container #pillowComments');

  commentsFields.forEach(function(commentsField) {
    const mipSaveButton = commentsField.closest('#panel-5').querySelector('#MIP-save');

    if (!mipSaveButton) {
      return;
    }

    // Comments is optional - the Save/Finish button on this last screen is
    // enabled regardless of whether anything's been typed here.
    mipSaveButton.removeAttribute('disabled');

    // typing here can still enable every OTHER screen's "Save Your
    // Selections" button, since it counts as information provided
    commentsField.addEventListener('input', syncAllSaveButtons);
  });
}

function restrictToDigits(input) {
  // fields marked pattern="[0-9]*" (Height feet/inches, Age) should only
  // ever hold digits — strip anything else live as the shopper types,
  // rather than only flagging it as invalid on submit
  input.addEventListener('input', function(event) {
    var digitsOnly = event.target.value.replace(/[^0-9]/g, '');
    if (digitsOnly !== event.target.value) {
      event.target.value = digitsOnly;
    }
  });
}

function initTextFields() {
  // Age is a plain text input (not radios) — restore any saved value. Its
  // Next button is never disabled (no required question in this flow); its
  // separate "Save Your Selections" button is handled together with every
  // other screen's by syncAllSaveButtons(). Height is handled separately by
  // initHeightField() below, since it's split across two inputs (feet +
  // optional inches).
  const textFields = document.querySelectorAll('.mip-container .content input[type="text"]:not(#heightFeetInput):not(#heightInchesInput)');

  textFields.forEach(function(textField) {
    const content = textField.closest('.content');
    if (!content) {
      return;
    }

    if (textField.getAttribute('pattern') === '[0-9]*') {
      restrictToDigits(textField);
    }

    const savedValue = localStorage.getItem(textField.name);
    if (savedValue !== null) {
      textField.value = savedValue;
    }

    textField.addEventListener('input', syncAllSaveButtons);
  });
}

function getHeightValue(content) {
  var feetInput = content.querySelector('#heightFeetInput');
  if (!feetInput || feetInput.value.trim() === '') {
    return null;
  }
  var inchesInput = content.querySelector('#heightInchesInput');
  var inches = inchesInput ? inchesInput.value.trim() : '';
  var value = feetInput.value.trim() + "'";
  if (inches !== '') {
    value += ' ' + inches + '"';
  }
  return value;
}

function initHeightField() {
  // both feet and inches are optional — whichever is filled in gets
  // combined into a single "Height" property value (e.g. 5' 6") when
  // Save/Next is clicked. Restoring on reopen parses that combined value
  // back into the two inputs rather than persisting feet/inches under
  // their own localStorage keys, since the "save every localStorage key
  // containing 'Height'" line-item sweep in the click handler would
  // otherwise add them as extra, separate line items alongside the
  // combined "Height" one.
  const feetInputs = document.querySelectorAll('.mip-container #heightFeetInput');

  feetInputs.forEach(function(feetInput) {
    const content = feetInput.closest('.content');
    if (!content) {
      return;
    }

    const inchesInput = content.querySelector('#heightInchesInput');

    restrictToDigits(feetInput);
    if (inchesInput) {
      restrictToDigits(inchesInput);
    }

    const savedHeight = localStorage.getItem('Height');
    if (savedHeight) {
      var match = savedHeight.match(/^(\d+)'(?:\s+(\d+)")?$/);
      if (match) {
        feetInput.value = match[1];
        if (inchesInput && match[2]) {
          inchesInput.value = match[2];
        }
      }
    }

    // Next is never disabled here - Height's "Save Your Selections" button
    // is handled together with every other screen's by syncAllSaveButtons().
    feetInput.addEventListener('input', syncAllSaveButtons);
    if (inchesInput) {
      inchesInput.addEventListener('input', syncAllSaveButtons);
    }
  });
}

function allowScroll() {
  var elements = document.querySelectorAll('.supports-touch, .lock-scroll');
  elements.forEach(function(element) {
    element.classList.remove('supports-touch', 'lock-scroll');
  });
}
